import { I18NextPipe } from 'angular-i18next';
import { StorageType } from 'mbs-ui-shared';
import {
  amazonS3GlacierStorageTypes,
  ftpStorageTypes,
  googleCloudStorageTypes,
  googleDriveStorageTypes,
  s3CompatibleStorages
} from 'mbs-ui-shared@constants/storage.constants';

export const ubStorageTypes = [StorageType.UbAmazonS3, StorageType.CblWasabi];

export const canAddDestination = [
  ...amazonS3GlacierStorageTypes,
  ...googleCloudStorageTypes,
  ...ubStorageTypes,
  ...googleDriveStorageTypes,
  ...s3CompatibleStorages,
  StorageType.Wasabi,
  StorageType.BackblazeB2,
  StorageType.FTP,
  StorageType.SFTP,
  StorageType.Azure,
  StorageType.Minio,
  StorageType.OpenStack,
  StorageType.OracleCloud,
  StorageType.IDriveE2,
  StorageType.ImpossibleCloud
];

// Mirrors the show-conditions of the storage actions dropdown items: an account matching none of them gets an empty menu
export function hasStorageActions(storage: {
  storageType: StorageType;
  isResellerAccount?: boolean;
  isPrivateStorage?: boolean;
  isReadOnly?: boolean;
}): boolean {
  return (
    (canAddDestination.includes(storage.storageType) && !storage.isResellerAccount) ||
    !storage.isPrivateStorage ||
    !storage.isReadOnly ||
    storage.storageType === StorageType.Azure
  );
}

export const canEditDestination = [...canAddDestination, StorageType.AzureVM, StorageType.LocalFS];

export const canEditStorage = [
  ...amazonS3GlacierStorageTypes,
  ...googleCloudStorageTypes,
  ...ubStorageTypes,
  ...googleDriveStorageTypes,
  StorageType.LocalFS,
  StorageType.AzureVM,
  StorageType.S3Compatible,
  StorageType.Wasabi,
  StorageType.BackblazeB2,
  StorageType.FTP,
  StorageType.SFTP,
  StorageType.Azure,
  StorageType.Minio,
  StorageType.OpenStack,
  StorageType.IDriveE2,
  StorageType.ImpossibleCloud
];

export const alternateDestinationFormStorageTypes = [...ftpStorageTypes, StorageType.LocalFS, StorageType.AzureVM];

export const awsStorageType = (i18N: I18NextPipe) => [
  {
    name: i18N.transform('storages:addStorageAccountWizard.inputCredentialsStep.labels.amazonS3'),
    type: StorageType.AmazonS3
  },
  {
    name: i18N.transform('storages:addStorageAccountWizard.inputCredentialsStep.labels.amazonS3Europe'),
    type: StorageType.AmazonS3Eu
  },
  {
    name: i18N.transform('storages:addStorageAccountWizard.inputCredentialsStep.labels.amazonS3China'),
    type: StorageType.AmazonS3Chinese
  }
];
